import { render, staticRenderFns } from "./ManagementGroup.vue?vue&type=template&id=4b2fcfb5&"
import script from "./ManagementGroup.vue?vue&type=script&lang=js&"
export * from "./ManagementGroup.vue?vue&type=script&lang=js&"
import style0 from "./ManagementGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports